// Source: https://www.brilliantbylangham.com/sc/member-benefits#comparison-chart
// Captured 2026-09-21, including the linked Hong Kong dining offer.
import onyx from './assets/onyx.webp';
import topaz from './assets/topaz.webp';
import diamond from './assets/diamond.webp';
import sapphire from './assets/sapphire.webp';
import ruby from './assets/ruby.webp';
import dining from './assets/dining.webp';

export const PAGE_TITLE = '朗廷卓逸会会员礼遇';

export const tiers = [
  {
    id: 'onyx', name: '玛瑙', image: onyx, points: '不设最低积分要求',
    introduction: '轻松成为朗廷卓逸会会员',
    benefits: ['会员专享房价', '九五折 / 八五折* 餐饮折扣']
  },
  {
    id: 'topaz', name: '托帕石', image: topaz, points: '12,000 会籍积分',
    introduction: '闪耀光芒，成为托帕石级会员',
    benefits: ['会员专享房价', '九五折 / 八五折* 餐饮折扣', '额外10%尊尚积分']
  },
  {
    id: 'diamond', name: '钻石', image: diamond, points: '108,000 会籍积分',
    introduction: '准备好迎接新挑战吗？升级至钻石级会员',
    benefits: ['会员专享房价', '九折 / 八五折* 餐饮折扣', '额外15%尊尚积分']
  },
  {
    id: 'sapphire', name: '蓝宝石', image: sapphire, points: '360,000 会籍积分',
    introduction: '迈向蓝宝石级别，令每次体验更添精彩',
    benefits: ['会员专享房价', '九折 / 八五折* 餐饮折扣', '额外25%尊尚积分']
  },
  {
    id: 'ruby', name: '红宝石', image: ruby, points: '720,000 会籍积分',
    introduction: '尽享红宝石级别极致奢华',
    benefits: ['会员专享房价', '九折 / 八五折* 餐饮折扣', '额外50%尊尚积分']
  }
];

export const overviewIntroduction = '从专属客房价格到餐厅、酒吧和水疗中心优惠，每个会籍级别都可以探索新的礼遇';

// Preserve the source table, including its dining percentages and empty cells.
// The source's higher-tier summaries separately state a 10% dining discount.
export const benefitRows = [
  { name: '官网直接预订专属房价', values: [true, true, true, true, true] },
  { name: '精彩餐饮优惠', values: ['5% / 15%*', '5% / 15%*', '5% / 15%*', '5% / 15%*', '5% / 15%*'] },
  { name: '额外尊尚积分', values: [null, '10%', '15%', '25%', '50%'] },
  { name: '客房升级奖赏礼券', values: [null, null, null, true, true] },
  { name: 'VIP活动体验', values: [null, true, true, true, true] },
  { name: '会员尊享体验邀请', values: [null, true, true, true, true] },
  { name: '客房偏好#', values: [true, true, true, true, true] },
  { name: '提前入住#', values: [null, null, true, true, true] },
  { name: '延迟退房#', values: [null, null, null, '2pm^', '4pm^'] },
  { name: '尊尚迎宾礼遇选项', values: [null, null, null, null, null], emphasized: true },
  { name: '尊尚奖励积分', values: [null, null, null, true, true] },
  { name: '迎宾饮品', values: [null, null, null, true, true] },
  { name: '餐饮消费额', values: [null, null, null, true, true] },
  { name: '迎宾礼品', values: [null, null, null, null, null] }
];

export const diningNotes = [
  '*只适用于香港地区餐厅: 会员凡于香港地区指定餐厅堂食消费，即享85折优惠，活动详情请',
  '*会员凡于香港以外地区的参与餐厅堂食消费，即享高达九折优惠：',
  '- 玛瑙及托帕石级别会员：九五折',
  '- 钻石、蓝宝石及红宝石级别会员：九折'
];

export const diningOffer = {
  title: 'Brilliant Feasts: 会员尊享85折餐饮优惠',
  location: '香港特别行政区',
  image: dining,
  introduction: [
    '朗廷卓逸会会员凡于香港地区指定餐厅堂食消费，即享85折优惠，并同时赚取积分。',
    '立即订座，把握机会肆意品尝由星级名厨炮制之各式佳肴。'
  ],
  heading: '品尝米其林美馔',
  description: '与老饕共聚，品尝多间已连续多年摘下米其林星级荣誉之殿堂级食府，共晋由名厨主理之多款星级名菜与世界美酒。',
  restaurants: [
    {
      name: '唐阁',
      description: '香港朗廷酒店米其林三星粤菜食府唐阁 (2021-2025)，呈献令人难忘的粤菜美食体验。在格调高雅的环境中，客人能细意品尝大厨严选顶级食材烹调的粤式珍馐百味。品尝行政总厨黄智辉与大厨团队精心创制的特色佳肴，体验不一样的感官享受。在等待美食的时候，不妨欣赏四周高雅的布艺装饰、一丝不苟的餐桌布置和一系列引人入胜的艺术品。'
    },
    {
      name: '明阁',
      description: '粤菜食府明阁，餐厅由明阁及中厨部行政总厨李悦发师傅及其团队主理，以经典的粤菜和世界美酒闻名。李悦发师傅拥有20多年的入厨经验，一直醉心烹调传统粤菜，严选最优质的食材为宾客呈现正宗的粤菜精粹。厨师团队以卓越厨艺和最优质而新鲜的食材，为宾客呈献精湛的广东美馔。'
    },
    {
      name: '逸东轩',
      description: '连续九年获颁米其林一星（2017-2025）的星级食府逸东轩由享负盛名的大厨谭栋主理，呈献经典地道的传统手工粤菜。餐厅装潢雅致，重现1920年代上海酒馆的气氛，为食客带来别具一格的精致餐饮享受。'
    }
  ],
  venues: [
    { hotel: '香港朗廷酒店', names: ['廷廊', 'The Food Gallery', '唐阁'] },
    { hotel: '香港康得思酒店', names: ['The Place', 'The Garage Bar', 'Alibi - Wine Dine Be Social', '明阁'] },
    { hotel: '香港逸东酒店', names: ['逸东轩', '普庆餐厅', 'Terrible Baby', '花样年华'] },
    { hotel: '', names: ['明阁 (湾仔)', 'Minato (湾仔)', '尚海荟'] }
  ],
  terms: [
    '朗廷卓逸会会员在中国香港地区内的参与餐厅堂食惠顾可享85折优惠（“优惠”）。',
    '会员可以在同一笔交易中享受优惠并赚取朗廷卓逸会积分。',
    '优惠仅适用于每张账单最多二十 (20) 位顾客。',
    '会员不能在同一笔交易中使用朗廷卓逸会会员餐饮折扣并兑换奖励积分。',
    '优惠不可与其他折扣或促销活动同时使用。',
    '优惠不适用于特定日子，包括但不限于公众假期、旺季及特别活动期间，并由相关酒店或餐厅酌情决定。',
    '会员必须在场，并在结算账单前出示其会员资料并自行结清付款（如使用其名下借记卡或信用卡）才能享用优惠。',
    '受朗廷卓逸会会员计划条款及细则约束，详情请参阅https://www.brilliantbylangham.com/sc/programme-terms-conditions。',
    '如有任何争议，朗廷卓逸会及参与餐厅保留最终决定权。'
  ]
};
